import { render, staticRenderFns } from "./CbsFilterConstructor.vue?vue&type=template&id=5f5ba70f&scoped=true"
import script from "./CbsFilterConstructor.vue?vue&type=script&lang=js"
export * from "./CbsFilterConstructor.vue?vue&type=script&lang=js"
import style0 from "./CbsFilterConstructor.vue?vue&type=style&index=0&id=5f5ba70f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ba70f",
  null
  
)

export default component.exports